import PropTypes from 'prop-types';
import Column from './Column.js';
import Filter from './Filter.js';
import Sort from './Sort.js';

const propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  column: PropTypes.string.isRequired,
  row: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([''])])
    .isRequired,
  showHeaderRow: PropTypes.bool,
  content: PropTypes.string,
  numberOfMaxLines: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['']),
  ]).isRequired,
  period: PropTypes.string,
  startedOn: PropTypes.string,
  endedOn: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape(Column.propTypes)),
  filters: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape(Filter.conditionShape))
  ),
  sorts: PropTypes.arrayOf(PropTypes.shape(Sort.propTypes)),
};

class Panel {
  static propTypes = propTypes;
}

export default Panel;
